import { secondAxios } from "../../../../../../api/axios";

const quoteIdent = (value) => `"${String(value).replace(/"/g, '""')}"`;

const extractRows = (response) =>
  Array.isArray(response?.data) ? response.data : [];

export async function listTables(dbName) {
  const response = await secondAxios.post("/sqlite-db/query", {
    dbName,
    sql: "SELECT name FROM sqlite_master WHERE type = 'table' AND name NOT LIKE 'sqlite_%' ORDER BY name",
  });
  return extractRows(response)
    .map((row) => row?.name)
    .filter(Boolean);
}

// Some imported sqlite tables carry a leftover header row as actual data
// (every column's value equals that column's own name) — drop it.
const isHeaderRow = (row) => {
  const keys = Object.keys(row).filter((key) => key !== "id");
  if (!keys.length) return false;
  return keys.every((key) => String(row[key] ?? "").trim() === key.trim());
};

export async function getTableRows(dbName, tableName) {
  const response = await secondAxios.post("/sqlite-db/query", {
    dbName,
    sql: `SELECT rowid AS id, * FROM ${quoteIdent(tableName)}`,
  });
  return extractRows(response).filter((row) => !isHeaderRow(row));
}

export async function updateTableRow(dbName, tableName, row) {
  const { id, ...columns } = row;
  const keys = Object.keys(columns);
  if (!keys.length) return null;

  const setClause = keys.map((key) => `${quoteIdent(key)} = ?`).join(", ");
  const params = [...keys.map((key) => columns[key]), id];

  return secondAxios.post("/sqlite-db/run", {
    dbName,
    sql: `UPDATE ${quoteIdent(tableName)} SET ${setClause} WHERE rowid = ?`,
    params,
  });
}
